<template>
    <div class="document-modal document input-full-width">
        <div class="modal-header">
            <h2 class="text-center">Attributter</h2>
        </div>

        <div class="example-description">
            <input type="text" placeholder="Filtere..." v-model.lazy="filter" class="filter-field">
        </div>
        <div class="map-modal-container">
            <div class="modal-grid">
                <tree :data="treeNodes" :filter="filter" :options="opts" ref="tree" class="tree-container">
                    <div slot-scope="{ node }" class="node-container">
                        <div @click="openFeature(node)" class="node-text">
                            {{node.text}}
                        </div>
                    </div>
                </tree>
                <div class="prop-container">
                    <div v-for="(property, index) in properties" class="node-feature">
                        <b>{{property.name}}</b>
                        <label class="node-prop">{{property.value}}</label>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal-footer">
            <div class="text-center modal-buttons">
                <button type="button" class="button-naked" @click="closeModal()">Luk</button>
            </div>
        </div>
    </div>
</template>

<script>
import LiquorTree from 'liquor-tree'
export default {
    name: 'map-modal',
    props: [
        'data'
    ],
    data () {
        return {
            treeNodes: [],
            filter: null,
            emptyText: 'Ingen resultat',
            opts: {
                filter: {
                    matcher (query, node) {
                        if (node.data.featureProperties) {
                            return node.data.featureProperties.some(p => p.name.toLowerCase() === query.toLowerCase() || p.value.toLowerCase() === query.toLowerCase())
                        }
                    }
                },
                checkbox: false,
                propertyName: {
                    text: 'name',
                    children: 'features'
                }
            },
            properties: null
        }
    },
    components: {
        'tree': LiquorTree
    },
    methods: {
        closeModal () {
            this.$emit('close')
        },
        openFeature (node) {
            this.properties = node.data.featureProperties
        }
    },
    created () {
        this.treeNodes = this.data.map(element => {
            return {
                text: element.name,
                state: {visible: true},
                children: element.features.map(feature => {
                    return {
                        text: feature.name,
                        data: {featureProperties: feature.properties},
                        state: {
                            visible: true
                        }
                    }
                })
            }
        })
    }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/map/map-modal.vue